import Feature24 from './Feature24'
export default Feature24
